import { Institution } from "@shared/models";

export interface FetchProfileResponse {
    status:  boolean;
    message: ProfileResponse;
}

export interface ProfileResponse {
    firstname:       string;
    lastname:        string;
    email:           string;
    number_phone:    number;
    address:         string;
    id_number:       number;
    institutions?:   Institution[];
}
